<template>
    <div class="vue-application">
        <template v-if="!getComponentName()">
            <div>Не указан компонент для подключения</div>
        </template>
        <template v-if="getComponentName() === 'router'">
            <router-view :application="getComponentData()"/>
        </template>
        <template v-if="getComponentName() === 'cart'">
            <cart :application="getComponentData()"/>
        </template>
        <template v-if="getComponentName() === 'smartFilter'">
            <smart-filter :application="getComponentData()"/>
        </template>
        <template v-if="getComponentName() === 'order'">
            <order :application="getComponentData()"/>
        </template>
        <template v-if="getComponentName() === 'autoCatalogFilter'">
            <auto-catalog-filter :application="getComponentData()"/>
        </template>
        <template v-if="getComponentName() === 'hlCatalogFilter'">
            <hl-catalog-filter :application="getComponentData()"/>
        </template>
        <template v-if="getComponentName() === 'register'">
            <register :application="getComponentData()"/>
        </template>
        <template v-if="getComponentName() === 'userProfiles'">
            <user-profiles :application="getComponentData()"/>
        </template>
        <template v-if="getComponentName() === 'forgot-pass'">
            <forgot-pass :application="getComponentData()"/>
        </template>
        <template v-if="getComponentName() === 'request-call'">
            <request-call :application="getComponentData()"/>
        </template>
        <template v-if="getComponentName() === 'feedback'">
            <feedback :application="getComponentData()"/>
        </template>
        <template v-if="getComponentName() === 'review'">
            <review :application="getComponentData()"/>
        </template>
        <template v-if="getComponentName() === 'login'">
            <login :application="getComponentData()"/>
        </template>
        <template v-if="getComponentName() === 'change-pass'">
            <change-pass :application="getComponentData()"/>
        </template>
    </div>
</template>

<script>
  import Cart from './components/cart/Cart'
  import SmartFilter from './components/smartFilter/SmartFilter'
  import Order from './components/order/Order'
  import CommonMixin from './mixins/common'
  import AutoCatalogFilter from './components/autoCatalogFilter/AutoCatalogFilter'
  import HlCatalogFilter from './components/hlCatalogFilter/HlCatalogFilter'
  import Register from './components/forms/Register'
  import UserProfiles from './components/userProfiles/UserProfiles'
  import ForgotPass from './components/forms/ForgotPass'
  import RequestCall from './components/forms/RequestCall'
  import Feedback from './components/forms/Feedback'
  import Review from './components/forms/Review'
  import Login from './components/forms/Login'
  import ChangePass from './components/forms/ChangePass'

  export default {
    name: 'app',
    props: {
      application: {
        type: Object,
        default () {
          return {}
        }
      }
    },
    mixins: [CommonMixin],
    components: {
      Cart,
      SmartFilter,
      Order,
      AutoCatalogFilter,
      HlCatalogFilter,
      Register,
      UserProfiles,
      ForgotPass,
      RequestCall,
      Feedback,
      Review,
      Login,
      ChangePass
    },
    data () {
      return {}
    },
    methods: {
      getComponentName () {
        try {
          return this.application.config.component.name
        } catch (error) {
          return ''
        }
      },
      getComponentData () {
        try {
          return this.application.config.component.data
        } catch (error) {
          return {}
        }
      }
    },
    created () {
      if (this.getComponentName() === 'order') {
        let componentData = this.getComponentData()
        if (!componentData.form.fields) {
          componentData.form.fields = {}
        }
        componentData.form.fields.personType = this.getCheckedItemId(
          componentData.order['PERSON_TYPE'])
        componentData.form.fields.userProfile = this.getCheckedItemId(
          componentData.order['USER_PROFILES'])
        componentData.form.fields.deliveryType = this.getCheckedItemId(
          componentData.order['DELIVERY'])
        componentData.form.fields.payType = this.getCheckedItemId(
          componentData.order['PAY_SYSTEM'])
      }
    } // Действия при создании
  }
</script>



// WEBPACK FOOTER //
// src/vue/App.vue